<template>
  <div class="bg-white p-3 row item-details">
    <div class="col-md-12">
      <router-link
        :to="{
          name: 'List Lost Items'
        }"
      >
        <i class="fas fa-chevron-left"></i>
        <span class="ml-3">{{ $t("lostItems.lostItemDetail.back") }}</span>
      </router-link>
    </div>
    <div class="col-md-6 mt-2">
      <h1>{{ $t("lostItems.lostItemDetail.title") }}</h1>
    </div>
    <div class="col-md-6 text-right">
      <div class="controls">
        <router-link
          class="cancel-btn mr-4"
          v-if="generalInfo.status !== 'details'"
          :to="{
            name: 'List Lost Items'
          }"
          >{{ $t("surveys.newSurvey.cancelBtn") }}</router-link
        >
        <button
          class="btn btn-update"
          @click="updateItem"
          v-if="generalInfo.status === 'waiting_collection'"
        >
          {{ $t("lostItems.btnUpdate") }}
        </button>
        <button
          class="btn btn-update"
          :class="
            categorySelected === 0 || inventoried === false
              ? 'disable-btn '
              : ''
          "
          @click="updateItem"
          v-if="generalInfo.status === 'collected'"
        >
          {{ $t("lostItems.btnUpdate") }}
        </button>
        <button
          class="btn btn-update"
          :class="resolution === '' ? 'disable-btn ' : ''"
          @click="updateItem"
          v-if="generalInfo.status === 'inventoried'"
        >
          {{ $t("lostItems.btnUpdate") }}
        </button>
      </div>
    </div>
    <div class="col-md-6 mt-5">
      <h4 class="mb-5 bolded">
        {{ $t("lostItems.lostItemDetail.subtitleInformation") }}
      </h4>

      <!-- Folio form -->
      <label class="bolded" for="folio">
        {{ $t("lostItems.lostItemDetail.folio") }}
      </label>
      <input
        type="text"
        id="folio"
        class="mb-3"
        v-model="folio"
        v-if="generalInfo.status === 'waiting_collection'"
        :placeholder="$t('lostItems.lostItemDetail.folioPlaceholder')"
      />
      <p
        v-if="
          generalInfo.status === 'collected' ||
            generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.folio }}
      </p>
      <!-- Folio form end -->
      <!-- Description form -->
      <label class="bolded" for="description">
        {{ $t("lostItems.lostItemDetail.description") }}
      </label>
      <input
        v-if="
          generalInfo.status === 'waiting_collection' ||
            generalInfo.status === 'collected'
        "
        type="text"
        id="description"
        v-model="itemInfo"
      />
      <p
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.itemInfo }}
      </p>
      <!-- Description form end-->

      <!-- date form -->

      <label class="mt-4 bolded">
        {{ $t("lostItems.lostItemDetail.dateHour") }}
      </label>
      <div v-if="generalInfo.status === 'waiting_collection'" class="date">
        <!-- <date-picker v-model="dateCollection" valuetype="format"></date-picker> -->
        <date-pick class="mt-3" v-model="dateCollection"></date-pick>
        <vue-timepicker
          class="ml-4 mt-1"
          v-model="timeCollection"
        ></vue-timepicker>
      </div>
      <p
        v-if="
          generalInfo.status === 'collected' ||
            generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.dateCollection }} {{ generalInfo.timeCollection }}
      </p>
      <!-- date form end-->

      <!-- placeCollection form -->
      <label class="mt-4 bolded">
        {{ $t("lostItems.lostItemDetail.placeCollection") }}
      </label>
      <input
        v-if="generalInfo.status === 'waiting_collection'"
        type="text"
        id="placeCollection"
        v-model="placeCollection"
      />
      <p
        v-if="
          generalInfo.status === 'collected' ||
            generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.placeCollection }}
      </p>
      <!-- placeCollection form end -->
      <!-- collector form -->
      <label
        v-if="
          generalInfo.status === 'collected' ||
            generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
        class="mt-4 bolded"
        >{{ $t("lostItems.lostItemDetail.collector") }}</label
      >
      <p
        v-if="
          generalInfo.status === 'collected' ||
            generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.collector }}
      </p>
      <!-- collector form end-->
      <!-- category form -->
      <!-- Mostrar Solo en la parte de recolectados -->
      <label
        v-if="
          generalInfo.status === 'collected' ||
            generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
        class="mt-4 bolded"
        >{{ $t("lostItems.lostItemDetail.category") }}</label
      >
      <select
        v-if="generalInfo.status === 'collected'"
        v-model="categorySelected"
      >
        <option disabled value>
          {{ $t("lostItems.lostItemDetail.categoryPlaceholder") }}
        </option>
        <option
          v-for="(category, index) in categories"
          :key="index"
          :value="category.id"
          >{{ category.name }}</option
        >
      </select>
      <p
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ currentCategory }}
      </p>
      <!-- category form end -->

      <!-- Mostrar solo en inventariado e historial -->
      <h4
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
        class="mb-3 mt-5 bolded"
      >
        {{ $t("lostItems.lostItemDetail.subtitleInventory") }}
      </h4>
      <label
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
        class="mt-1 bolded"
        >{{ $t("lostItems.lostItemDetail.invetoriedBy") }}</label
      >
      <p
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.inventoriedBy }}
      </p>
      <label
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
        class="mt-4 bolded"
        >{{ $t("lostItems.lostItemDetail.dateHour") }}</label
      >
      <p
        v-if="
          generalInfo.status === 'inventoried' ||
            generalInfo.status === 'details'
        "
      >
        {{ generalInfo.inventoryDate }} {{ generalInfo.inevntoryTime }}
      </p>
    </div>
    <div class="col-md-6 der">
      <div class="status">
        <h5 class="bolded">{{ $t("lostItems.lostItemDetail.status") }}</h5>
        <div class="row align-items-center">
          <img
            v-if="generalInfo.status === 'waiting_collection'"
            src="../../assets/img/icon/pendiente.png"
          />
          <img
            v-if="generalInfo.status === 'collected'"
            src="../../assets/img/icon/recolectado.png"
          />
          <img
            class="ml-3"
            v-if="
              generalInfo.status === 'inventoried' ||
                generalInfo.status === 'details'
            "
            src="../../assets/img/icon/check.png"
          />
          <span
            class="bolded"
            v-if="generalInfo.status === 'waiting_collection'"
            >{{ $t("lostItems.lostItemDetail.pending") }}</span
          >
          <span class="bolded" v-if="generalInfo.status === 'collected'">
            {{ $t("lostItems.lostItemDetail.collected") }}
          </span>
          <span
            class="bolded ml-2"
            v-if="generalInfo.status === 'inventoried'"
            >{{ $t("lostItems.lostItemDetail.inventoried") }}</span
          >
          <span
            v-if="
              generalInfo.status === 'details' &&
                generalInfo.resolution !== null
            "
            class="bolded ml-2"
          >
            {{ generalInfo.resolution }}
          </span>
          <span
            class="bolded ml-2"
            v-if="
              generalInfo.status === 'details' &&
                generalInfo.resolution === null
            "
            >{{ $t("lostItems.lostItemDetail.noResolution") }}</span
          >
          <label
            class="mt-2 ml-4"
            for="collected"
            v-if="generalInfo.status === 'waiting_collection'"
          >
            <input
              type="checkbox"
              v-model="collected"
              :disabled="folio === ''"
              id="collected"
            />
            {{ $t("lostItems.lostItemDetail.collected") }}
          </label>

          <label
            class="mt-2 ml-4"
            for="collected"
            v-if="generalInfo.status === 'collected'"
          >
            <input
              type="checkbox"
              v-model="inventoried"
              :disabled="categorySelected === 0"
              id="collected"
            />
            {{ $t("lostItems.lostItemDetail.inventoried") }}
          </label>
        </div>
        <p
          class="red-text"
          :class="folio === '' ? '' : 'no-show'"
          v-if="generalInfo.status === 'waiting_collection'"
        >
          {{ $t("lostItems.lostItemDetail.enterFolio") }}
        </p>
        <p
          class="red-text"
          :class="categorySelected === 0 ? '' : 'no-show'"
          v-if="generalInfo.status === 'collected'"
        >
          {{ $t("lostItems.lostItemDetail.enterCategory") }}
        </p>
        <!-- mostrar solamente en inventariado -->
        <div
          class="resolution-radios"
          v-if="generalInfo.status === 'inventoried'"
        >
          <h5 class="bolded">
            {{
              $t("lostItems.tabs.Inventoried.table.headings.resolutionAction")
            }}
          </h5>
          <div class="radios">
            <div class="gruop mr-3">
              <input
                type="radio"
                v-model="resolution"
                value="delivered"
                name="radio"
                id="delivery"
              />
              <label for="delivery">
                {{ $t("lostItems.lostItemDetail.delivery") }}
              </label>
            </div>
            <div class="gruop mr-3">
              <input
                type="radio"
                v-model="resolution"
                value="donated"
                name="radio"
                id="donated"
              />
              <label for="donated">
                {{ $t("lostItems.lostItemDetail.donated") }}
              </label>
            </div>
            <div class="gruop mr-3">
              <input
                type="radio"
                v-model="resolution"
                value="destroyed"
                name="radio"
                id="destroyed"
              />
              <label for="destroyed">
                {{ $t("lostItems.lostItemDetail.destroyed") }}
              </label>
            </div>
          </div>
        </div>
        <div
          @click="addComment = true"
          v-if="generalInfo.status === 'inventoried'"
        >
          <p
            class="text-right comments"
            :class="resolution === '' ? 'disable-comment' : 'comments'"
            v-if="!addComment"
          >
            {{ $t("lostItems.lostItemDetail.addComments") }}
            <img src="../../assets/img/icon/plus-btn.png" class="ml-2" />
          </p>
        </div>
        <h5 v-if="addComment === true" class="bolded mt-4">
          {{ $t("lostItems.lostItemDetail.commentary") }}
        </h5>
        <textarea
          :placeholder="$t('lostItems.lostItemDetail.commentaryPlaceholder')"
          v-if="addComment === true"
          class="comments-area"
          v-model="comments"
        ></textarea>
        <!-- mostrar solamente en inventariado end -->
      </div>
      <div class="details mt-5">
        <h4 class="mb-3 bolded">
          {{ $t("lostItems.lostItemDetail.collectionRequestorDetails") }}
        </h4>
        <label class="bolded">{{ $t("lostItems.lostItemDetail.name") }}</label>
        <p>{{ generalInfo.userName }}</p>

        <label class="bolded mt-3">{{
          $t("lostItems.lostItemDetail.tel")
        }}</label>
        <p>{{ generalInfo.phone }}</p>

        <label class="bolded mt-3">{{
          $t("lostItems.lostItemDetail.email")
        }}</label>
        <p class="mb-5">{{ generalInfo.email }}</p>
      </div>
      <div class="resolution-info" v-if="generalInfo.resolution !== null">
        <h4 class="mb-3 bolded">
          {{ $t("lostItems.lostItemDetail.resolutionInformation") }}
        </h4>
        <label class="bolded mt-3">{{
          $t("lostItems.lostItemDetail.resolvedBy")
        }}</label>
        <p>{{ generalInfo.resolvedBy }}</p>

        <label class="bolded mt-3">{{
          $t("lostItems.lostItemDetail.dateHour")
        }}</label>
        <p>{{ generalInfo.resolutionDate }} {{ generalInfo.resolutionTime }}</p>
        <label class="bolded mt-3">{{
          $t("lostItems.lostItemDetail.commentary")
        }}</label>
        <p class="mb-5" v-if="generalInfo.commentary !== null">
          {{ generalInfo.commentary }}
        </p>
        <p class="mb-5" v-if="generalInfo.commentary === null">
          {{ $t("lostItems.lostItemDetail.withOutComments") }}
        </p>
      </div>
      <!-- Solo area de investigacion -->
      <div class="delete">
        <i
          v-if="
            generalInfo.status === 'waiting_collection' ||
              generalInfo.status === 'collected' ||
              generalInfo.status === 'inventoried'
          "
          class="far fa-trash-alt"
        ></i>
        <span
          class="ml-2"
          v-if="generalInfo.status === 'waiting_collection'"
          @click="openModal"
        >
          {{ $t("lostItems.lostItemDetail.deleteSolicitude") }}
        </span>
        <span
          class="ml-2"
          v-if="generalInfo.status === 'collected'"
          @click="openModal"
        >
          {{ $t("lostItems.lostItemDetail.deleteCollected") }}
        </span>
        <span
          v-if="generalInfo.status === 'inventoried'"
          class="ml-2"
          @click="openModal"
          >{{ $t("lostItems.lostItemDetail.deleteInventoried") }}</span
        >
      </div>
    </div>
    <!-- Modal -->
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title bolded">
          {{ $t("lostItems.tabs.collectionRequests.modal.attention") }}
        </h6>
      </template>
      <template>
        <div class="modal-body-text">
          <p>{{ $t("lostItems.tabs.collectionRequests.modal.delete-text") }}</p>
          <p class="mt-1">
            {{ $t("lostItems.tabs.collectionRequests.modal.body-text2") }}
          </p>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">
            {{ $t("map.benefits.list.modal.cancel") }}
          </span>
          <button
            type=" button"
            class="btn control solve-btn"
            @click="deleteItem()"
          >
            {{ $t("lostItems.tabs.collectionRequests.modal.continue") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import API_SERVICE from "@/lib/api/lostItems.js";
import moment from "moment";
const Modal = () => import("@/components/Modal");

const api = new API_SERVICE();
export default {
  components: {
    VueTimepicker,
    DatePick,
    Modal
  },
  data() {
    return {
      timeCollection: null,
      dateCollection: null,
      folio: "",
      itemInfo: "",
      placeCollection: "",
      categories: [],
      generalInfo: null,
      collected: false,
      inventoried: false,
      itemId: 0,
      categorySelected: 0,
      currentCategory: "",
      resolution: "",
      addComment: false,
      comments: "",
      modalActive: false
    };
  },
  async beforeMount() {
    await this.getCategory();
    this.fillData();
  },
  methods: {
    fillData: function() {
      try {
        let obj = this.$route.params.object;
        let id = this.$route.params.id;
        this.itemInfo = obj.itemInfo;
        this.dateCollection = obj.dateCollection;
        this.timeCollection = obj.timeCollection;
        this.placeCollection = obj.placeCollection;
        this.generalInfo = obj;
        this.itemId = id;
        if (this.generalInfo.status === "inventoried") {
          let currentCat = this.categories.filter(
            cat => cat.id === this.generalInfo.categoryId
          );
          this.currentCategory = currentCat[0].name;
          let formatDate = moment(this.generalInfo.inventoryDate).format(
            "YYYY-MM-DD"
          );
          let formatTime = moment(this.generalInfo.inventoryDate).format(
            "HH:MM"
          );
          this.generalInfo.inventoryDate = formatDate;
          this.generalInfo.inevntoryTime = formatTime;
        }
        if (this.$route.params.details) {
          this.generalInfo.status = "details";
          let formatDate = moment(this.generalInfo.resolutionDate).format(
            "YYYY-MM-DD"
          );
          let formatTime = moment(this.generalInfo.resolutionDate).format(
            "HH:MM"
          );
          this.generalInfo.resolutionDate = formatDate;
          this.generalInfo.resolutionTime = formatTime;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getCategory: async function() {
      let currentLanguage = localStorage.getItem("lang");
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getLostItemsCategorys(currentLanguage);
        this.categories = resp.categories;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    updateItem: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        if (
          this.folio === "" &&
          !this.collected &&
          this.generalInfo.status === "waiting_collection"
        ) {
          const autor = this.$store.getters["session/author"];
          let params = {
            status: "waiting_collection",
            itemInfo: this.itemInfo,
            dateCollection: this.dateCollection,
            timeCollection: this.timeCollection,
            placeCollection: this.placeCollection
          };

          const response = await api.updateItem(this.itemId, params);

          this.$router.push({
            name: "List Lost Items"
          });
        } else if (
          this.folio !== "" &&
          this.collected &&
          this.generalInfo.status === "waiting_collection"
        ) {
          const autor = this.$store.getters["session/author"];
          let params = {
            status: "collected",
            folio: this.folio,
            collector: autor,
            itemInfo: this.itemInfo,
            dateCollection: this.dateCollection,
            timeCollection: this.timeCollection,
            placeCollection: this.placeCollection
          };

          const response = await api.updateItem(this.itemId, params);

          this.$router.push({
            name: "List Lost Items"
          });
        }
        if (
          this.categorySelected !== 0 &&
          this.inventoried &&
          this.itemInfo !== "" &&
          this.generalInfo.status === "collected"
        ) {
          const autor = this.$store.getters["session/author"];
          let params = {
            status: "inventoried",
            inventoriedBy: autor,
            itemInfo: this.itemInfo,
            inventoryDate: new Date(),
            categoryId: this.categorySelected,
            dateCollection: this.generalInfo.dateCollection,
            timeCollection: this.generalInfo.timeCollection,
            placeCollection: this.generalInfo.placeCollection
          };

          const response = await api.updateItem(this.itemId, params);
          this.$router.push({
            name: "List Lost Items"
          });
        }
        if (
          this.generalInfo.status === "inventoried" &&
          this.resolution !== ""
        ) {
          const autor = this.$store.getters["session/author"];

          let params = {
            status: "inventoried",
            resolvedBy: autor,
            resolutionDate: new Date(),
            resolution: this.resolution,
            commentary: this.comments,
            published: false,
            dateCollection: this.generalInfo.dateCollection,
            timeCollection: this.generalInfo.timeCollection,
            placeCollection: this.generalInfo.placeCollection,
            itemInfo: this.generalInfo.itemInfo
          };
          const response = await api.updateItem(this.itemId, params);
          this.$router.push({
            name: "List Lost Items"
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    deleteItem: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        this.generalInfo.published = false;
        this.generalInfo.status = "deleted";
        const response = await api.updateItem(this.itemId, this.generalInfo);
        this.$router.push({
          name: "List Lost Items"
        });
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
        this.itemToDelete = null;
      }
    },
    openModal: async function() {
      this.modalActive = true;
    },
    closeModal: function() {
      this.modalActive = false;
    }
  }
};
</script>

<style>
.mx-input {
  background-color: transparent;
  border-radius: 0px;
}
.vdpComponent {
  font-size: 13px !important;
}
.der {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.der .status {
  background: #f2f2f2;
  border: 1px solid #999999;
  width: 80%;
  padding: 2rem;
}
.der .details,
.der .resolution-info {
  width: 80%;
}
.vdpCell.selected .vdpCellContent {
  background: #000 !important;
}
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #000;
}
.red-text {
  color: #bb0a30;
}
.bolded {
  font-weight: bold;
}
.date {
  display: flex;
  align-items: center;
}
.delete {
  position: absolute;
  bottom: 0;
  right: 6%;
  cursor: pointer;
}
a {
  color: #000;
  text-decoration: none;
}
a:hover {
  color: #000;
}
.no-show {
  display: none;
}
.controls .cancel-btn {
  cursor: pointer;
}
.controls .cancel-btn:hover {
  text-decoration: underline;
}
.controls .btn-update {
  background: #000;
  border-radius: 0px;
  color: #fff;
}
.disable-btn {
  background: rgba(0, 0, 0, 0.3) !important;
  pointer-events: none;
}
.resolution-radios {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  margin-top: 1rem !important;
}
.resolution-radios .radios {
  display: flex !important;
}
.resolution-radios .radios .gruop {
  display: flex !important;
  align-items: center !important;
}
.resolution-radios .radios .gruop label {
  padding-top: 5px !important;
  margin-left: 1rem !important;
}
.comments {
  cursor: pointer;
}
.disable-comment {
  color: #aaaaaa;
  pointer-events: none;
}
.comments-area {
  width: 100%;
  max-height: 100px;
  min-height: 100px;
  height: 100px;
}
.item-details .modal-container {
  max-width: 20vw !important;
  max-height: 60vh !important;
}
.item-details .modal-container .controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}
.bolded {
  font-weight: bold !important;
}
.controls span {
  cursor: pointer;
}
.controls span:hover {
  text-decoration: underline;
}
</style>
